import { Link } from 'react-router-dom'
import { Twitter, Github } from 'lucide-react'

const watermarkLinks = [
  { name: 'SynthID', href: '/watermarks/synthid' },
  { name: 'C2PA', href: '/watermarks/c2pa' },
  { name: 'Stable Signature', href: '/watermarks/stable-signature' },
  { name: 'DALL-E Watermark', href: '/watermarks/dall-e-watermark' },
  { name: 'All Watermarks', href: '/watermarks' },
]


const toolLinks = [
  { name: 'AI Detector', href: '/check' },
  { name: 'Make Undetectable', href: '/undetectable' },
  { name: 'Enhance Realism', href: '/enhance-realism' },
  { name: 'Metadata Cleaner', href: '/tools/metadata-cleaner' },
]

const browseLinks = [
  { name: 'Watermarks', href: '/watermarks' },
  { name: 'AI Services', href: '/services' },
  { name: 'AI Models', href: '/models' },
]

const benchmarkLinks = [
  { name: 'Detector Rankings', href: '/' },
  { name: 'Arena', href: '/arena' },
]

const companyLinks = [
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' },
  { name: 'Terms', href: '/terms' },
  { name: 'Privacy', href: '/privacy' },
  { name: 'Partners', href: '/partners' },
]

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="AI Detector Arena" className="w-8 h-8" />
              <span className="font-semibold text-gray-800">AI Detector Arena</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Compare AI image detectors. Live benchmarks, ELO rankings, accuracy stats.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Browse</h3>
            <ul className="space-y-2">
              {browseLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Popular</h3>
            <ul className="space-y-2">
              {watermarkLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Tools</h3>
            <ul className="space-y-2">
              {toolLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Benchmark */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Benchmark</h3>
            <ul className="space-y-2">
              {benchmarkLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Company</h3>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} AI Detector Arena. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://dofollow.tools"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://dofollow.tools/badge/badge_dark.svg"
                alt="Featured on Dofollow.Tools"
                width="150"
                height="40"
                className="opacity-70 hover:opacity-100 transition-opacity"
              />
            </a>
            <a
              href="https://twitter.com/aidetectarena"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://github.com/aidetectarena"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
